export const BEGIN_TIME_TIMESTAMP = -8640000000000000;
export const END_TIME_TIMESTAMP = 8640000000000000;
export const NOT_VALID = "**DCSVLY/NOTVALID**";

export const BEGIN_TIME_STRING = "-271821-04-20T00:00:00.000Z";
export const END_TIME_STRING = "+275760-09-13T00:00:00.000Z";

